import {
  Button, Col, Flex, Row
} from "antd";
import { ReactNode } from "react";
import Container from "../container";
import { useNav } from "../../hooks/useNav";

const AdvantagesScreen = ({ title, description, hasGrayBackground = true }: {
  title?: string | ReactNode;
  description?: string;
  hasGrayBackground?: boolean;
}) => {
  const { navExperts } = useNav();

  return (
    <div className={`${hasGrayBackground ? "bg-themeGray" : ""} py-[3rem]`}>
      <Container>
        <h2 className="heading text-center">
          {title || "I nostri punti di forza"}
        </h2>
        {description && (
          <p className="text-center text-base mb-10">{description}</p>
        )}
        <Row gutter={[32, 32]} justify="center">
          <Col span={24} md={12} lg={8}>
            <Flex
              vertical
              align="center"
              className="text-center"
            >
              <img
                src="/landing/home/home-5-1.svg"
                alt="icon"
                className="w-[120px]"
              />
              <strong className="text-xl">Supporto psiconcologico personalizzato</strong>
            </Flex>
          </Col>
          <Col span={24} md={12} lg={8}>
            <Flex
              vertical
              align="center"
              className="text-center"
            >
              <img
                src="/landing/home/home-5-2.svg"
                alt="icon"
                className="w-[120px]"
              />
              <strong className="text-xl">Terapie online sicure</strong>
            </Flex>
          </Col>
          <Col span={24} md={12} lg={8}>
            <Flex
              vertical
              align="center"
              className="text-center"
            >
              <img
                src="/landing/home/home-5-3.svg"
                alt="icon"
                className="w-[120px]"
              />
              <strong className="text-xl">
                Altissima specializzazione dei nostri professionisti
              </strong>
            </Flex>
          </Col>
        </Row>
        <Flex justify="center" gap={12} className="mt-[40px]">
          <Button
            onClick={navExperts}
            size="large"
            type="primary"
            className="wideButton"
          >
            Prenota la tua visita
          </Button>
        </Flex>
      </Container>
    </div>
  );
};

export default AdvantagesScreen;
